import { Injectable } from '@angular/core';

import { SearchSource } from 'src/api/models'; 
import { DataService } from 'src/api/services';

@Injectable()
export class StorageTablesService {
  public rows: Array<SearchSource>;
  public lastCustomerId: number;
  constructor(private dataService: DataService) { }
  
  getAllRows(customerId: number, onLoad): void {
    if (!this.rows || this.lastCustomerId != customerId) {
      this.lastCustomerId = customerId;
      this.rows = [];
      this.dataService.DataSearch({customerId: customerId, search: " ", searchSize: 5000, pageIndex: 0, includeAlarms: false, filterOld: true})
        .subscribe(
          res => {
            this.rows = res ?? [];
            if (onLoad){
              onLoad();
            }
          },
          err => {
            console.error("ERROR: getAllRows", err);
          }
        );
    }
  }
}
